export default __webpack_public_path__ + "static/media/SERIE.9fec4ab0.gif";